<script>
    const mapPin = 'assets/mapPin.svg';
    const mail = 'assets/mail.svg';

    let formSubmitted = false;
    let recaptcheUnchecked = true;
    let formData = {};
    let errorsSubmittingForm = false;

    const handleOnSubmit = (e) => {
        e.preventDefault()

        for(let i=0; i < 3; i++) {
            formData = {...formData, ...{[e.target[i].dataset.key]: e.target[i].value}}
        }

        doPost(formData)

    } 

    window.recaptchaCallback = (value) => {
        recaptcheUnchecked = !recaptcheUnchecked;
        formData.recaptcha = value;
    };

    async function doPost (data) {
		const res = await fetch('https://niowmbo.isun.ch/api/v1/contact/email', {
			method: 'POST',
			body: JSON.stringify(data),
            headers: {
                 "Content-Type": "application/json",
            }
		})

        !res.ok ? errorsSubmittingForm = await res.json() : formSubmitted = true 

	}



</script>

        <div class="container" id='contact'>
            <div class="getInTouchContainer">
                <div class="getInTouchInfo">
                    <div class="getInTouchHeader">Get in touch</div>
                    <div class="getInTouchSubHeader">Contact with our team by filling in the form or using contacts details down below</div>
                    <div class="getIntouchCredentials">
                        <div>
                            <img src={mapPin} alt='mapPin'/>
                        </div>
                        <div>
                            <div> Dlouhá 730/35 </div> 
                            <div> 110 00 Praha 1 - Staré Město </div>
                            <div> Czech Republic </div>
                        </div>
                    </div>
                    <div class="getIntouchCredentials"> 
                        <div>
                            <img src={mail} alt='mail'/>
                        </div>
                        <div> support@niowm.com </div>
                    </div>
                </div>
                {#if !formSubmitted}
              

                    <form class="getInTouchForm" on:submit={handleOnSubmit}>
                        {#if errorsSubmittingForm && !formSubmitted}    
                            <div class="getInTouchFormError">
                                {#each errorsSubmittingForm.errors as errors }
                                    <div>{errors.message}</div>
                                {/each}
                            </div>  
                        {/if}

                        <div class="getInTouchFormInputs">
                            <input placeholder="Full name" data-key="name" type="text"/>
                            <input placeholder="Your email address" data-key="email" type="text"/>
                        </div>
                        <textarea placeholder='Your message area' data-key="message"></textarea>
                    
                        <div class="g-recaptcha" data-callback="recaptchaCallback" data-sitekey="6Lfwx_gZAAAAADQCAtmlQ_xwauygSOunByqVCGRL"></div>
                        <button type="submit" class='getInTouchFormSubtmitButton' disabled={recaptcheUnchecked}>Send message</button>
                    </form>
                {:else if formSubmitted}
                    <div class="getInTouchFormSuccess">
                        Thank you 😊
                    </div>
                 
                {/if}
            
            </div>  
        </div>

<style>
    .container{
        margin: 100px 0;
        padding: 0 30px;
     }

     .getInTouchContainer{
        max-width: 1170px;
        margin: 0 auto;
     }

     .getInTouchContainer{
        display: flex;
        justify-content: space-between;
     }

     .getInTouchHeader{
        font-size: 32px;
        letter-spacing: -1px;
        line-height: 36px;
     }

     .getInTouchSubHeader{
        font-size: 20px;
        line-height: 26px;
        margin:  20px 0;
     }

     .getInTouchForm{
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 32px;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.09);
        margin-left: 100px;
     }

     .getInTouchFormSuccess{
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 32px;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.09);
        margin-left: 100px;
        justify-content: center;
        align-items: center;
        width: 100%;
     }

     .getInTouchFormError{
        text-align: center;
     }
     .getInTouchFormError > div{
        margin-bottom: 10px;
        color:  red;
     }

     .g-recaptcha{
        margin-bottom: 20px;
     }

     .getInTouchFormSubtmitButton{
        background: linear-gradient(180deg, #F77E36 0%, #EB6210 100%);
        border-radius: 4px;
        width: 302px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 16px;
        cursor: pointer;
    }

    .getInTouchFormSubtmitButton:disabled{
        background: linear-gradient(180deg, #e0c1ae 0%, #ecb290 100%);

    }

    .getInTouchFormInputs{
        display: flex;
    }

    .getInTouchFormInputs > input{
        width: 100%;
        height: 50px;
    } 
    .getInTouchFormInputs > input:first-child{
        margin-right: 20px;
    } 

    .getInTouchForm > textarea{
        margin: 20px 0;
        height: 100px;
        resize: none;
    }

    .getIntouchCredentials{
        display: flex;
        margin-bottom: 30px;
    }

    .getIntouchCredentials > div:first-child{
        margin-right: 20px;
    }


    @media (max-width: 769px) { 


        .g-recaptcha{
            position: relative;
            transform: scale(0.8);
            left: -35px;
        }

        .container{
            margin: 50px 0;
        }


        .getInTouchContainer {
            flex-direction: column;
        }

        .getInTouchForm, .getInTouchFormSuccess {
            margin-left: 0px;
            width: auto;
        }

        .getInTouchFormInputs {
            flex-direction: column;
        }

        .getInTouchFormSubtmitButton{
            width: auto;
        }

        .getInTouchFormInputs > input:first-child{
            margin: 0;
        }
        .getInTouchFormInputs > input:last-child {
            margin: 20px 0;
        }

        .getInTouchForm  > textarea{
            margin: 0 0 20px 0;
        }   

     }


</style>